import { Injectable } from '@angular/core';

import { ExistingConsequenceType } from 'libs/domain';

import { CacheService } from '@app/src/app/shared/services/cache/cache.service';
import { CacheKey } from '@app/src/app/shared/services/cache/cache.types';

import { ModalOverlayService, ModalOverlayServiceCloseEventType } from '@shared/components/modal-overlay';
import { SystemAlertSnackBarService } from '@shared/components/system-alert-snackbar';

import { BehaviorManagerService } from '../../../services';
import { BmTypesConsequenceEditComponent } from '../components/bm-types-consequence-edit/bm-types-consequence-edit.component';
import { BmTypesConsequenceEditModalData, BmTypesConsequenceEditModalResponse } from '../types';

@Injectable()
export class BmTypesConsequenceService {
  /** Service Constructor */
  constructor(
    private _systemSnackbar: SystemAlertSnackBarService,
    private _modalOverlay: ModalOverlayService<BmTypesConsequenceEditModalResponse, BmTypesConsequenceEditModalData>,
    private _bmService: BehaviorManagerService,
    private _cacheService: CacheService,
  ) {}

  public async openEditModal(type?: ExistingConsequenceType): Promise<void> {
    const editModal = this._modalOverlay.open(BmTypesConsequenceEditComponent, {
      data: { consequenceType: type },
      disposeOnNavigation: false,
    });
    editModal.afterClosed.subscribe(async response => {
      if (!response) return;
      switch (response.type) {
        case ModalOverlayServiceCloseEventType.CREATE: {
          this._systemSnackbar.success('Successfully created new consequence type');
          this._cacheService.clearCacheByNamespace(CacheKey.SELECTION_ASSIGNER_CAROUSEL);
          return;
        }
        case ModalOverlayServiceCloseEventType.SUBMIT: {
          await this._bmService.fetchConsequenceTypes();
          this._systemSnackbar.success('Successfully updated consequence type');
          this._cacheService.clearCacheByNamespace(CacheKey.SELECTION_ASSIGNER_CAROUSEL);
          return;
        }
        case ModalOverlayServiceCloseEventType.DELETE: {
          this._systemSnackbar.success('Successfully deleted consequence type');
          this._cacheService.clearCacheByNamespace(CacheKey.SELECTION_ASSIGNER_CAROUSEL);
          return;
        }
        default: {
          return;
        }
      }
    });
  }

  public async changeStatus(consequenceType: ExistingConsequenceType, status: boolean): Promise<void> {
    try {
      const type = { ...consequenceType };
      type.active = status;
      await this._bmService.updateConsequenceType(type);
      this._systemSnackbar.success(`Successfully set ${type.name} to ${status ? 'active' : 'inactive'}`);
      this._cacheService.clearCacheByNamespace(CacheKey.SELECTION_ASSIGNER_CAROUSEL);
    } catch (error) {
      this._systemSnackbar.error(`Failed to update consequence status`);
    }
  }
}
